import classNames from "classnames"
//import { FixedHeightFlag } from 'use-flags'
import colors from '../../config/colors.json'
import { useQuery } from "react-query";
import { getBackendUrl } from '../../helpers/url';

export function LiveGameNamePlate({ name, civ, country, color, leftSide, teamIcon }) {

    const fetchCivs = async () => {
        const res = await fetch(`${getBackendUrl()}/api/config/civs`);
        return res.json();
    };

    const {data, status} = useQuery("civs", fetchCivs);

    const selectedCiv = data?.find((value) => value.aoe2cm === civ || value.label === civ);

    return (
        <div className="h-[92px] mt-[2px] flex flex-col justify-center" >
            <div className={classNames(``,"-z-10 absolute flex", leftSide ? 'flex-row-reverse -mr-[2px]' : 'flex-row')}>
                <img src={selectedCiv?.originalFlag} className="liveGameOverlay__topBar-civFlag w-[164px] h-[92px]" style={{ maskImage: `linear-gradient(to ${!leftSide ? 'left' : 'right'}, transparent, black)`, WebkitMaskImage: `linear-gradient(to ${!leftSide ? 'left' : 'right'}, transparent, black)` }} alt="" />
                {teamIcon &&
                    <img src={teamIcon} className={classNames('liveGameOverlay__topBar-teamIcon w-10 h-10 my-auto opacity-50 mx-1')} alt="" />
                }
            </div>
            <div className={classNames("liveGameOverlay__topBar-playerName-country flex ", leftSide ? 'justify-end pr-8 -ml-8 flex-row' : 'justify-end pl-8 -mr-8 flex-row-reverse')}>

                <h1 className={`liveGameOverlay__topBar-playerName text-xl font-bold`} style={{ color: colors[color]?.mainColor }}>{name}</h1>
                {country &&
                    <div className="rounded-full">
                        <img src={`https://flagcdn.com/h24/${country.toLowerCase()}.png`} className="w-[26px] h-[26px] object-none rounded-full mx-1 border-[#FFC700] border-[1px]" alt="" />
                    </div>
                }
            </div>
            <h1 className={classNames("liveGameOverlay__topBar-civName w-[125%] flex text-white text-lg italic", leftSide ? "justify-end -ml-[4.5rem]" : "justify-start pl-8")} style={{ textShadow: '2px 2px 3px black' }}>{selectedCiv?.label}</h1>
        </div>
    )
}